import { useTranslation } from 'react-i18next';
import DetailCard from '../shared/DetailCard';
import ViewCourse from '../shared/ViewCourses';
import Button from '@/components/common/Button';
import Modal from '@/components/common/Modal';
import type { GroupListItemDataFragment, SubgroupListItemDataFragment } from '@/gql/graphql';

interface ViewSubgroupProps {
    open: boolean;
    group?: GroupListItemDataFragment;
    subgroup?: SubgroupListItemDataFragment;
    onClose: () => void;
}

const ViewSubgroup = ({ open, onClose, group, subgroup }: ViewSubgroupProps) => {
    const { t } = useTranslation('groups');

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={subgroup?.name || t('viewSubgroupModal.title')}
            largeTitle
            className="mt-2 w-full space-y-4 sm:max-w-3xl sm:min-w-[600px]"
            footer={
                <div className="mt-5 pt-4 sm:mt-4 sm:flex sm:flex-row sm:items-center sm:justify-end">
                    <Button onClick={onClose} variant="secondary">
                        {t('viewSubgroupModal.close')}
                    </Button>
                </div>
            }
        >
            {group && (
                <div className="flex flex-col gap-5">
                    <DetailCard group={group} subgroup={subgroup} />
                    <ViewCourse group={group} subgroup={subgroup} />
                </div>
            )}
        </Modal>
    );
};

export default ViewSubgroup;
